class PreferredContact extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.methodInput = this.querySelector('[data-contact-method]');
    this.emailField = this.querySelector('[data-email-field]');
    this.emailInput = this.querySelector('[data-email-input]');
    this.phoneField = this.querySelector('[data-phone-field]');
    this.phoneInput = this.querySelector('[data-phone-input]');
    this.countryInput = this.querySelector('[data-phone-country]');
    this.propertyInput = this.querySelector('[data-contact-property]');

    if (!this.methodInput || !this.emailInput || !this.phoneInput || !this.propertyInput) return;

    this.methodInput.addEventListener('change', () => this.updateMethod());
    this.emailInput.addEventListener('input', () => this.updateProperty());
    this.phoneInput.addEventListener('input', () => this.formatPhone());
    this.closest('form')?.addEventListener('submit', () => this.updateProperty());

    this.updateMethod();
  }

  updateMethod() {
    const usesEmail = this.methodInput.value === 'Email';

    this.emailField.hidden = !usesEmail;
    this.phoneField.hidden = usesEmail;
    this.emailInput.disabled = !usesEmail;
    this.emailInput.required = usesEmail;
    this.phoneInput.disabled = usesEmail;
    this.phoneInput.required = !usesEmail;
    this.countryInput.disabled = usesEmail;

    this.updateProperty();
  }

  formatPhone() {
    const rawValue = this.phoneInput.value.trim();
    let digits = rawValue.replace(/\D/g, '');
    if ((rawValue.startsWith('+1') || digits.length === 11) && digits.startsWith('1')) digits = digits.slice(1);
    digits = digits.slice(0, 10);

    let formatted = '+1';
    if (digits.length > 0) formatted += ` (${digits.slice(0, 3)}`;
    if (digits.length >= 3) formatted += ')';
    if (digits.length > 3) formatted += ` ${digits.slice(3, 6)}`;
    if (digits.length > 6) formatted += `-${digits.slice(6, 10)}`;

    this.phoneInput.value = formatted;
    this.updateProperty();
  }

  updateProperty() {
    const value = this.methodInput.value === 'Email' ? this.emailInput.value.trim() : this.phoneInput.value.trim();
    this.propertyInput.value = `${this.methodInput.value}\n${value}`;
  }
}

if (!customElements.get('preferred-contact')) {
  customElements.define('preferred-contact', PreferredContact);
}
